import { render, staticRenderFns } from "./SubscriptionDetailDialog.vue?vue&type=template&id=5473aeb4&scoped=true"
import script from "./SubscriptionDetailDialog.vue?vue&type=script&lang=js"
export * from "./SubscriptionDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionDetailDialog.vue?vue&type=style&index=0&id=5473aeb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5473aeb4",
  null
  
)

export default component.exports